var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SelectFilter',{ref:"select",staticClass:"fitlerSelect border-class",attrs:{"hide-details":"","type":"SubjectLabel","value":_vm.value,"selectedItems":_vm.value,"multiple":"","returnObject":false,"selectedArea":_vm.selectedArea},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }